/* BIONIKA - lapozas/kategoriavaltas utan a termekracs tetejere gorgetes (sticky fejlec figyelembe vetelevel) */
(function(){
  'use strict';
  function headerH(){
    var h=document.querySelector('.section-header')||document.querySelector('sticky-header')||document.querySelector('.header-wrapper');
    if(!h) return 0; var b=h.getBoundingClientRect().bottom; return b>0?b:0;
  }
  function gridTopAbs(){
    var g=document.getElementById('ProductGridContainer')||document.getElementById('main-collection-filters');
    if(!g) return null; return g.getBoundingClientRect().top + window.pageYOffset;
  }
  function toGrid(smooth){
    var t=gridTopAbs(); if(t===null) return;
    var y=Math.max(0, t - headerH() - 8);
    try{ window.scrollTo({top:y, behavior:smooth?'smooth':'auto'}); }catch(e){ window.scrollTo(0,y); }
  }
  function pg(){ try{ return parseInt(new URLSearchParams(location.search).get('page')||'1',10)||1; }catch(e){ return 1; } }
  function onload(){ if(pg()>1){ toGrid(false); setTimeout(function(){toGrid(false);},150); } }
  if(document.readyState==='complete'){ onload(); } else { window.addEventListener('load', onload); }
  var last=location.pathname+'|'+pg();
  function check(){ var now=location.pathname+'|'+pg(); if(now!==last){ last=now; setTimeout(function(){toGrid(true);},60); } }
  ['pushState','replaceState'].forEach(function(m){
    var orig=history[m]; if(typeof orig!=='function') return;
    history[m]=function(){ var r=orig.apply(this,arguments); try{check();}catch(e){} return r; };
  });
  window.addEventListener('popstate', function(){ setTimeout(check,60); });
})();
